import axios from 'axios';
import { IBannersResponseData } from '@/interfaces/banner.interface';

export const bannerService = {
  async getCurrentBannerProd() {
    const response = await axios.get<IBannersResponseData>(`https://bookz.ru/api/admin_panel_router/baners/curent_baner`);
    return response;
  },
};
